export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 py-2 md:py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="text-sm md:text-2xl font-black text-[#0A1628] font-serif whitespace-nowrap">
          万燈
        </div>

        {/* CTA Button */}
        <a 
          href="https://forms.gle/vdJZoFV3tEuxApQD7"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative bg-gradient-to-r from-[#D4AF37] to-[#F4C542] text-[#0A1628] font-bold text-[10px] md:text-base px-2 md:px-8 py-1.5 md:py-3 rounded-full flex items-center gap-1 md:gap-3 hover:shadow-xl hover:shadow-[#D4AF37]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-serif"
        >
          【無料】WEBセミナーに申し込む
          <div className="w-5 h-5 md:w-8 md:h-8 flex items-center justify-center bg-white rounded-full group-hover:translate-x-1 transition-transform duration-300 flex-shrink-0">
            <i className="ri-arrow-right-line text-[#0A1628] text-xs md:text-lg"></i>
          </div>
        </a>
      </div>
    </header>
  );
}
